/**
 * Represents a value that can be converted into a javascript date.
 * This includes a number (timestamp), and ISO formatted string, or another Date object
 */
export type DateLike = string | number | Date;
